module.exports = __webpack_public_path__ + "img/icon_nav6_active.26b75174.385e076f.svg";